<object type="image/svg+xml" data="/assets/images/top10-icons.svg" style="display:none;"></object>
  
<div
  *ngIf="brandService.view === 'fru' && userExiting"
  class="motivate-popup"
  (click)="closeExitIntentPopup()"
>
  <div class="motivate-dialog" [@inFormPopup] (click)="$event.stopPropagation()">
    <img
      class="close-exit-intent-popup"
      src="/assets/images/grey-x.png"
      (click)="closeExitIntentPopup()"
    />    
    <div class="motivate-title">
      Leaving Already?
    </div>

    <div class="motivate-text">
      {{ 'You\'re moments away from receiving your ' + (form.controls.formType.value != 'debtsettlement' && this.form.controls.formType.value != 'debtrelief' ? 'rate' : 'options') + ' from the top lenders in your area, FREE!' }}
    </div>

    <div style="text-align: center;">
      <button
        class="motivate-button continue has-shadow-small"
        style="width: 350px;"
        (click)="closeExitIntentPopup()"
      >
        Click to Continue
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <div class="motivate-logo-container">
      <img class="motivate-logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" *ngIf="brandService.logoSrc">
    </div>
  </div>
</div>

<!-- <div class="selected-prompt-wraper" *ngIf="showPrompt && promptAllowed">
  <div class="selected-prompt">
    <h2 class="title is-size-4-mobile">{{ promptText }}</h2>
    <button class="button continue is-large has-shadow-small" (click)="continueWith('yes')">
      Yes&nbsp;&nbsp;&nbsp;&nbsp;
      <i class="fas fa-chevron-right"></i>
    </button>

    <button class="button continue is-large has-shadow-small" (click)="continueWith('no')">
      No&nbsp;&nbsp;&nbsp;&nbsp;
      <i class="fas fa-chevron-right"></i>
    </button>

    <div style="font-family: Tahoma; font-size: 14px; padding: 4px; margin-top: 40px;">
      We take your privacy seriously. By clicking the button above, You agree that we can share your personal data with third parties, such as our mortgage partners, service providers and other affiliates, and that we can use this data for marketing and analytics, and to make your experience easier. you are also providing your<b>express written consent</b> to have your information shared and to be matched with up to five <a *ngIf="!fruLocalKiosk" href="/approved-lenders" target="_new" rel="nofollow">approved lenders</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">approved lenders</a> and for them, or their authorized third party, to call you at the number you have provided including through automated means such as autodialing, text SMS/MMS (charges may apply), and prerecorded messaging, and/or via email, even if your telephone number is a cellular phone number or on a corporate, state, or the National Do Not Call Registry, and you agree to our Privacy Policy <a *ngIf="!fruLocalKiosk" href="/privacy" target="_new" rel="nofollow">Privacy Policy</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">Privacy Policy</a>. Consent is not required as a condition to utilize FreeRateUpdate's services, you may choose to use our services by calling 855-315-7283. Consent is not contingent on the purchase and/or use of any services being offered by a Lender.
    </div>
  </div>
</div> -->

<app-link-click-modal *ngIf="fruLocalKiosk" [isModalActive]="showModal" (closed)="toggleModal()"></app-link-click-modal>
<header>
  <nav [ngClass]="['navbar', 'is-light', brandService.view === 'best' ? 'best' : '', newDesignTop10FormABTest ? 'ab-new-design-top10-form' : '']">
    <div class="container">
      
      <div class="navbar-brand">
        <p>
          <!-- <img class="logo" src="/assets/images/recommended_logo.png" alt="Recommended Lender" *ngIf="recommendedLenderActive"> -->
          <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" *ngIf="brandService.logoSrc && !recommendedLenderActive" [errorSrc]="brandService.logoWasabiSrc">
        </p>
      </div>

      <div class="navbar-end" *ngIf="officeStatus && officeStatus.answer && !fruLocal && !isTopTenBestLenders">
        <p class="has-text-grey-dark is-size-6">or call for rates...</p>

        <p class="is-size-4 has-text-weight-semibold">
          <a href="tel:{{officeStatus.phone}}" target="_blank" (click)="phoneClicked()">
            <i class="fas fa-phone"></i>
            {{ officeStatus.phonefancy }}
          </a>
          <span class="experiment_chat_wrapper" *ngIf="chatButtonTestStatus">
            <i role="button" class="fas fa-comment experiment_chat_button"></i>
            Chat
          </span>
        </p>
      </div>
    </div>
  </nav>
</header>

<section [ngClass]="['section', brandService.view === 'best' ? 'best' : '', newDesignTop10FormABTest ? 'ab-new-design-top10-form' : '']" id="rates-form"
         [ngStyle]="{ 'padding-top' : fruLocalKiosk ? '4.5rem' : '1.5rem'}"
         [class.p2h-form]="brandService.domain.includes('pathtohome')">
  <div class="container" [ngStyle]="{'position': showModal ? 'sticky' : 'relative'}">
    <form class="has-text-centered app-step-form-border-radius"
    [ngClass]="{
      'fixed_height': fruLocalKiosk,
      'bg-hidden': isSubmitting,
    }"
    [style]="'background: transparent;'"    
    [formGroup]="form" (keydown.enter)="$event.preventDefault()">

      <div *ngIf="currentStepKey > 0" class="go-back-arrow">
        <input type="image" (click)="goBack()" src="/assets/images/button/go-back-black-arrow-icon.png" alt="Submit" width="20px">
      </div>

      <div class="secure_form"><span><i class="fa fa-lock"></i> Secure</span></div>

      <app-step
        class="app-step app-step-floating-card {{step.key}}"
        [ngStyle]="{'margin-top': currentStepKey > 0 ?'7%':'5%', 'background': '#fff'}"
        *ngFor="let step of steps"
        [type]="step.component"
        (stepEvent)="nextStep()"
        [@stepState]="step.state"
        [selectedLenders] = "availableSelected$ | async"
        [isSelectedLeads] = "isSelectedLeads$ | async"
        [isUncheckedTest] = "isUncheckedTest$ | async"
        [isBeEnabled] = "isBeEnabled$ | async"
        (@stepState.done)="stepAnimationDone()">
      </app-step>
      <input type="hidden" name="universal_leadid" id="leadid_token" value="">
    </form>
  </div>

  <footer id="rates-form-footer" *ngIf="brandService.view !== 'best' && !fruLocalKiosk">
    <div class="container">
      <div class="columns is-mobile app-step-footer-border-radius" [ngStyle]="{'padding-top': '3.2rem', 'background': 'transparent'}">
      </div>
    </div>
  </footer>

  <footer [ngClass]="brandService.view === 'best' ? 'best' : ''" id="rates-form-footer"
          [ngStyle]="{'padding-bottom': leadDisclosure ?'10vh':'20vh'}"
          *ngIf="(!newDesignTop10FormABTest && (brandService.view === 'best' || fruLocalKiosk))">
    <div class="container">
      <div class="columns is-mobile app-step-footer-border-radius" *ngIf="!isSecureForm">
        <div class="column is-two-thirds">
          <div class="align-badges">
            <div>
              <img src="/assets/images/data-privacy.png" class="secure_form_img">
            </div>
            <div class="bbb-image" *ngIf="!isTopTenBestLenders">
              <img src="/assets/images/bbb-a-plus-rating.gif" alt="Better Business Bureau A+ Rated" width="80">
            </div>
          </div>
        </div>

        <div class="column is-one-third has-text-right" *ngIf="brandService.view !== 'best'">
          <a *ngIf="!fruLocalKiosk" (click)="adDisclosurePopup()" style="white-space: nowrap;">
            * Advertising Disclosure
          </a>
        </div>
      </div>      
      <!-- fruLocalKiosk  -->
      <div class="start-over" *ngIf="fruLocalKiosk && !showModal">
        <p class="is-size-4 has-text-weight-semibold">
          <a (click)="redirectToStartOver()">
            <i class="fas fa-rotate-left"></i>
            Start over
          </a>
        </p>
      </div>
    </div>
  </footer>     
</section>

<footer class="footer" *ngIf="brandService.view !== 'best' && !fruLocalKiosk">
  <div class="footer-art"></div>
  <div class="footer-content">
    <div class="container">
      <p>
        <a href="/contact" target="_blank">Contact</a> &middot;
        <a href="/privacy" rel="nofollow" target="_blank">Privacy</a> &middot;
        <a href="/glba" rel="nofollow" target="_blank">GLBA</a> &middot;
        <a href="/cpra_policy" rel="nofollow" target="_blank">CPRA</a> &middot;
        <a href="/terms" rel="nofollow" target="_blank">Terms</a> &middot;
        <a href="/licensing_disclosure" rel="nofollow" target="_blank">Licensing Disclosure</a> &middot;
        <a *ngIf="!fruLocalKiosk" (click)="adDisclosurePopup()" style="white-space: nowrap;">* Advertising Disclosure</a> &middot;
        <a class="not-sell" href="/your_privacy_choices">Preferences</a> &middot;
        <a href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1154338" target="_blank">NMLS #1154338</a>
      </p>
    </div>
  </div>
</footer>

<footer class="footer is-size-7" *ngIf="fruLocalKiosk" style="padding-bottom: 1rem;">
  <div class="container">
    <p style="margin-top: 1rem;text-align: center;">Freerateupdate.com is a Marketing Lead Generator, as defined in the General Terms, and is compensated by Lenders for the services provided. FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. © FreeRateUpdate.com LLC 2008 - {{ currentYear }}. All Rights Reserved. 
      <a (click)="toggleModal()">Privacy Policy</a> | <a (click)="toggleModal()">* Advertising and Licensing Disclosures</a></p>
  </div>
</footer>

<footer
  [ngClass]="{
    'footer': true,
    'is-size-7': true,
    'has-text-centered-touch': true,
    'ab-secure': isSecureForm,
    'ab-new-design-top10-form': newDesignTop10FormABTest
  }"
  *ngIf="brandService.view === 'best' &&  !fruLocalKiosk"
>
  <nav class="navbar is-light">
    <div class="container">
      <div class="navbar-brand is-block-touch">
        <p>
          <!-- 
            <img class="logo" src="/assets/images/recommended_logo.png" alt="Recommended Lender" *ngIf="recommendedLenderActive">
            <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" *ngIf="brandService.logoSrc && !recommendedLenderActive" [errorSrc]="brandService.logoWasabiSrc">
          -->
        </p>
      </div>

      <div class="navbar-end">
        <a *ngIf="!isSecureForm" class="navbar-item has-text-grey-light" href="/contact" target="_blank">
          Contact Us
        </a>
        <a class="navbar-item has-text-grey-light" href="/privacy" target="_blank">
          Privacy<span *ngIf="!isSecureForm"> Policy</span>
        </a>
        <a class="navbar-item has-text-grey-light" href="/glba" target="_blank">
          GLBA Policy
        </a>
        <a class="navbar-item has-text-grey-light" href="/cpra_policy" target="_blank">
          CPRA Policy
        </a>
        <a class="navbar-item has-text-grey-light" href="/terms" target="_blank">
          General<span *ngIf="!isSecureForm"> Terms</span>
        </a>
        <a class="navbar-item has-text-grey-light" href="/licensing_disclosure" target="_blank">
          Licensing Disclosure
        </a>
        <a class="navbar-item has-text-grey-light" href="/your_privacy_choices" target="_blank">
          Privacy Preferences
        </a>
      </div>
    </div>
  </nav>

  <div class="container" *ngIf="!isSecureForm">
    <div class="copyright">
      <div class="columns">
        <div class="column flex-end" *ngIf="!newDesignTop10FormABTest">
          {{ currentYear }} &copy; All Rights Reserved
        </div>

        <div class="column poweredby" *ngIf="!isTopTenBestLenders">
          <img class="logo" src="/images/logo-medium.png">
          <br>
          Powered by FreeRateUpdate
        </div>

        <div class="column has-text-right-desktop has-text-centered flex-end-right" *ngIf="!isTopTenBestLenders">
          2 Ponds Edge Drive, Chadds Ford, PA 19317
        </div>
      </div>

      <p class="mt-5" *ngIf="!isTopTenBestLenders">
        Freerateupdate.com is a Marketing Lead Generator, as defined in the General Terms, and is compensated by Lenders for the services provided.
        FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. &copy; FreeRateUpdate.com LLC 2008 - {{ currentYear }}. All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.
      </p>

      <div *ngIf="isTopTenBestLenders" class="is-size-7 disclosure" style="margin: 10px auto;">
        <p class="first">Top10bestlenders.com is a Marketing Lead Generator, as defined in the General Terms, and is compensated by Lenders for the services provided. Top10bestlenders.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 440 Peoples Plaza, Newark, DE 19702. NMLS Unique Identifier #2620807. NMLS Consumer Access - <a href="https://nmlsconsumeraccess.org" target="_blank">nmlsconsumeraccess.org</a>  © Top10bestlenders.com LLC 2008 - 2024. Top10bestlenders.com Corp is Licensed Mortgage Originator as required by law. All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.</p>
        <p class="first">LEAD GENERATOR ONLY, NOT ACTING IN THE CAPACITY OF A MORTGAGE LOAN ORIGINATOR, MORTGAGE BROKER, MORTGAGE CORRESPONDENT LENDER OR MORTGAGE LENDER. INFORMATION RECEIVED WILL BE SHARED WITH ONE OR MORE THIRD PARTIES IN CONNECTION WITH YOUR RESIDENTIAL MORTGAGE LOAN INQUIRY</p>
        <p class="first"> CT: <strong>MORTGAGE BROKER ONLY</strong>, NOT A MORTGAGE LENDER OR MORTGAGE CORRESPONDENT LENDER.</p>
          <h6>Advertising Disclosure</h6>
          <p class="second">This site acts as a free online resource that tries to offer helpful content and comparison features to our visitors. We accept advertising compensation from companies that appear on the site. Company listings on this page DO NOT imply endorsement. We do not feature all providers on the market. Except as expressly set forth in our <a href="/terms" target="_blank">Terms of Use</a>, all representations and warranties regarding the information presented on this page are disclaimed. The information, including pricing, which appears on this site is subject to change at any time. Placement on the site could be impacted by compensation.</p>
      </div>
      <div *ngIf="newDesignTop10FormABTest">
        {{ currentYear }} &copy; All Rights Reserved
      </div>
    </div>
  </div>
</footer>

<section class="section" id="dev-debug" *ngIf="debug">
  <pre>{{form.value | json}}</pre>
</section>

<div id="form-modal" class="modal">
  <div class="modal-background"></div>
</div>

<div id="loadSpinner" *ngIf="isSubmitting">
  <h3>Hang tight. We're finding additional lenders and gathering information plus website links.</h3>
  <h4>This will only take a moment.</h4>
  <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</div>
